var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-modal",
    {
      ref: "modalEdicion",
      attrs: { size: "l", title: "Usuario" },
      on: { close: _vm.cerrarModal }
    },
    [
      _c(
        "div",
        { staticClass: "p-4", attrs: { slot: "header" }, slot: "header" },
        [_c("h4", [_vm._v("Usuario")])]
      ),
      _vm.user
        ? _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col w-1/4" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-full",
                    attrs: {
                      label: "RUT",
                      maxlength: "10",
                      name: "iut",
                      danger: _vm.errors.has("data-user.iut"),
                      "danger-text": _vm.errors.first("data-user.iut")
                    },
                    model: {
                      value: _vm.user.iut,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "iut", $$v)
                      },
                      expression: "user.iut"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 mt-3" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-full",
                    attrs: {
                      label: "Nombre del usuario",
                      maxlength: "60",
                      name: "name",
                      danger: _vm.errors.has("data-user.name"),
                      "danger-text": _vm.errors.first("data-user.name")
                    },
                    model: {
                      value: _vm.user.nombre,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "nombre", $$v)
                      },
                      expression: "user.nombre"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 mt-3" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-full",
                    attrs: {
                      label: "Alias",
                      maxlength: "60",
                      name: "alias",
                      danger: _vm.errors.has("data-user.alias"),
                      "danger-text": _vm.errors.first("data-user.alias")
                    },
                    model: {
                      value: _vm.user.alias,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "alias", $$v)
                      },
                      expression: "user.alias"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 mt-3" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "w-full",
                    attrs: {
                      label: "Correo electrónico",
                      maxlength: "50",
                      name: "email",
                      danger: _vm.errors.has("data-user.email"),
                      "danger-text": _vm.errors.first("data-user.email")
                    },
                    model: {
                      value: _vm.user.correo,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "correo", $$v)
                      },
                      expression: "user.correo"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "vx-col w-1/4" }, [
                _c(
                  "div",
                  {
                    staticClass: "mt-3 mb-2",
                    staticStyle: { "font-size": "0.85rem" }
                  },
                  [_vm._v("Perfil de usuario")]
                ),
                _c("ul", { staticClass: "leftx" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: { "vs-value": "admin" },
                          model: {
                            value: _vm.user.profileType,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "profileType", $$v)
                            },
                            expression: "user.profileType"
                          }
                        },
                        [_vm._v("Administrador")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: { "vs-value": "usuario" },
                          model: {
                            value: _vm.user.profileType,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "profileType", $$v)
                            },
                            expression: "user.profileType"
                          }
                        },
                        [_vm._v("Usuario")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "vx-row" }),
            _c(
              "div",
              { staticClass: "mt-3", staticStyle: { "text-align": "right" } },
              [
                !_vm.user.id
                  ? _c(
                      "vs-button",
                      {
                        attrs: { color: "primary", type: "filled" },
                        on: { click: _vm.crearUsuario }
                      },
                      [_vm._v("Crear ")]
                    )
                  : _vm._e(),
                _vm.user.id
                  ? _c(
                      "vs-button",
                      {
                        attrs: { color: "primary", type: "filled" },
                        on: { click: _vm.actualizarUsuario }
                      },
                      [_vm._v("Actualizar ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }